/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
// import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import Table from "../../../../components/common/new/Table/Table";
import {
  EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL,
  EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_ENTRANCE,
} from "../../../../contants/table/memberSearch";
// import tableStyle from "../../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";
import styles from "./styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import { PERMISSIONS } from "../../../../contants";
// import EyeIcon from "../../../../assets/svg/Eye";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "16rem",
  },
};

function AppliedMemberTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberToggle,
  onMemberStatusToggleForHelpDesk,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isClusterSi,
  isZoneSi,
  isHelpDeskAdmin,
  onMemberReactivateToggle,
}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let columns =
    queryParams?.get("examLevel") === "ENTRANCE"
      ? EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL
      : EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_ENTRANCE;

  if (hasPermission(PERMISSIONS.DEACTIVATE_EXAMINATION_APPLIED_MEMBER)) {
    columns = [
      ...columns,
      // {
      //   displayName: "Action",
      //   key: "action",
      // },
    ];
  }

  const getRows = ({ searchData }) =>
    (searchData || [])
      .sort((a, b) => {
        if (a.attendeeType === b.attendeeType) return 0;
        if (a.attendeeType === "Member") return -1;
        if (b.attendeeType === "Member") return 1;
        return 0;
      })
      .map((memberInfo) => {
        const person = memberInfo; // top-level object
        const isMember = memberInfo?.attendeeType === "Member";
        const info = isMember ? memberInfo.member : memberInfo.friend;

        return (
          <TableRow>
            <TableCell style={tabelCellWidth.medium}>
              <Typography style={styles.typoghrphyStyle}>
                {isMember ? info?.memberId : info?.friendId}
              </Typography>
            </TableCell>
            {queryParams?.get("examLevel") === "ENTRANCE" && (
              <TableCell style={tabelCellWidth.small}>
                <div style={styles.tableBox}>
                  <Typography
                    style={{
                      ...styles.typoghrphyStyle,
                      color:
                        memberInfo?.attendeeType === "Friend"
                          ? "#25b615"
                          : undefined,
                    }}
                  >
                    {memberInfo?.attendeeType || "-"}
                  </Typography>
                </div>
              </TableCell>
            )}
            <TableCell style={tabelCellWidth.small}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {person?.rollNumber || "-"}
                </Typography>
              </div>
            </TableCell>
            <TableCell style={tabelCellWidth.medium}>
              <Typography style={styles.typoghrphyStyle}>
                {person?.memberName || "N/A"}
              </Typography>
              {/* <br />
            <div style={styles.tableBox}>
              <LocationOnIcon style={tableStyle.locationIcon} />
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {info?.addressLine1}
                </Typography>
              </div>
            </div> */}
            </TableCell>
            <TableCell style={tabelCellWidth.medium}>
              {/* <PhoneIcon style={tableStyle.icon} /> */}
              <Typography style={styles.typoghrphyStyle}>
                {info?.mobileNumber}
              </Typography>
              {/* <br />
            <div style={styles.tableBox}>
              <EmailIcon style={tableStyle.icon} />
              <Typography style={styles.typoghrphyStyle}>
                {info?.emailId || "-"}
              </Typography>
            </div> */}
            </TableCell>
            <TableCell style={tabelCellWidth.small}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {info?.divisionName || "-"}
                </Typography>
              </div>
            </TableCell>
            <TableCell style={tabelCellWidth.large}>
              <div style={styles.tableBoxNoOverFlow}>
                <Typography style={styles.typoghrphyStyle}>
                  {[
                    info?.areaName,
                    info?.clusterName,
                    info?.zoneName,
                    info?.regionName,
                    info?.chapterName,
                    info?.districtName,
                    info?.blockName,
                  ]
                    .filter(Boolean) // remove undefined/null
                    .join("/ ") || "-"}
                </Typography>
              </div>
            </TableCell>
            {/* <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.areaName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.zoneName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.regionName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.chapterName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.districtName || "-"}
              </Typography>
            </div>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {info?.blockName || "-"}
              </Typography>
            </div>
          </TableCell> */}
            {/* {hasPermission(PERMISSIONS.DEACTIVATE_EXAMINATION_APPLIED_MEMBER) && (
            <TableCell style={tabelCellWidth.small}>
              <DoNotDisturbIcon
                style={{
                  ...styles.actionIcon,
                  color: "#7DEB6D",
                  fontSize: "1.5rem",
                }}
                onClick={() => onMemberToggle(memberInfo)}
              />
            </TableCell>
          )} */}
          </TableRow>
        );
      });
  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberToggle,
          onMemberStatusToggleForHelpDesk,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isClusterSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onMemberReactivateToggle,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          // textAlign: "left",
        }}
      />
    </div>
  );
}

export default AppliedMemberTable;
